(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ingredients"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const searchInput = document.getElementById('ingredientsearch');
    const filters = document.querySelectorAll('.category-filter');
    const items = document.querySelectorAll('.ingredient-card');
    const ingredientDetails = document.querySelectorAll('.ingredient-category-detail');
    const overlay = document.querySelector('.ingredient-popup-overlay');
    const details = document.querySelectorAll('.ingredient-detail');

    if (!items.length) return;

    let activeCategory = 'all';

    filters.forEach((filter) => {
      filter.addEventListener('click', () => {
        activeCategory = filter.dataset.category.toLowerCase();

        filters.forEach((btn) => btn.classList.remove('bg-lightSage', 'font-semibold'));
        filter.classList.add('bg-lightSage', 'font-semibold');

        applyFilters();
        toggleIngredientDetails();
      });
    });

    if (searchInput) {
      searchInput.addEventListener('input', applyFilters);
    }

    function applyFilters() {
      const query = searchInput?.value.trim().toLowerCase() || '';

      items.forEach((item) => {
        const name = item.querySelector('h3')?.textContent.trim().toLowerCase() || '';

        const categories = (item.dataset.category || '')
          .split(',')
          .map((cat) => cat.trim().toLowerCase())
          .filter(Boolean);

        const matchesSearch = query === '' || name.includes(query);
        const matchesCategory = activeCategory === 'all' || categories.includes(activeCategory);

        item.classList.toggle('hidden', !(matchesSearch && matchesCategory));
      });
    }

    function toggleIngredientDetails() {
      ingredientDetails.forEach((detail) => {
        const detailCategory = detail.dataset.category.toLowerCase();

        const shouldShow = activeCategory !== 'all' && detailCategory === activeCategory;

        detail.classList.toggle('hidden', !shouldShow);
      });
    }

    items.forEach((card) => {
      card.addEventListener('click', () => {
        const ingredient = card.dataset.ingredient;

        details.forEach((detail) => detail.classList.add('hidden'));

        overlay.classList.remove('hidden');

        const activeDetail = overlay.querySelector(`.ingredient-detail[data-ingredient="${ingredient}"]`);

        if (activeDetail) {
          activeDetail.classList.remove('hidden');
        }
      });
    });

    function closeOverlay() {
      overlay.classList.add('hidden');
      details.forEach((detail) => detail.classList.add('hidden'));
    }

    overlay.addEventListener('click', (e) => {
      if (e.target.closest('button') || e.target === overlay) {
        closeOverlay();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !overlay.classList.contains('hidden')) {
        closeOverlay();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
